import React from 'react'
import { ScreenReaderOnly } from '@moonpig/launchpad-components'
import {
  StyledDot,
  StyledDotsRow,
  StyledLabel,
  ThinkingMessageStyledBox,
} from './styled'
import { useLocaleText } from '../../locale'

export const ThinkingMessage = () => {
  const t = useLocaleText()
  const labelId = 'chat-thinking-message-label'
  const contentId = 'chat-thinking-message-content'

  return (
    <ThinkingMessageStyledBox
      aria-labelledby={`${labelId} ${contentId}`}
      data-testid="chat-thinking-message"
      role="article"
    >
      <ScreenReaderOnly id={labelId}>
        {t('concierge_chat.screen_reader_assistant_label')}
      </ScreenReaderOnly>
      <StyledDotsRow aria-hidden="true">
        <StyledDot $delay="0s" />
        <StyledDot $delay="0.15s" />
        <StyledDot $delay="0.3s" />
      </StyledDotsRow>
      <StyledLabel id={contentId}>
        {t('concierge_chat.thinking_title')}
      </StyledLabel>
    </ThinkingMessageStyledBox>
  )
}
